import React, {Component} from 'react';
import SmartForm from '../form/base.jsx'
import { Col, Row} from 'react-bootstrap';

class InternalProjectsForm extends Component{

  componentWillMount() {

    if(this.props.internalProjects.itemId){
      this.props.internalProjectsItem(this.props.internalProjects.itemId)
    }

    this.props.userList()

    this.props.settingsProjectLikelihoodList()
  }

  componentWillReceiveProps(nextProps) {
    if((nextProps.internalProjects.addSuccess && nextProps.internalProjects.addSuccess !== this.props.internalProjects.addSuccess) || (nextProps.internalProjects.editSuccess && nextProps.internalProjects.editSuccess !== this.props.internalProjects.editSuccess)){
      this.props.internalProjectsShowList()
    }
  }

  render(){
    let itemData, users = [], projectLikelihood =[]

    if(this.props.user.data){
      for(let i=0; i<this.props.user.data.length; i++){

        if(this.props.user.data[i].role && this.props.user.data[i].role.capabilities && this.props.user.data[i].role.capabilities.can_be_officer_in_charge){
          users.push({
            name: this.props.user.data[i].name,
            value: this.props.user.data[i].id
          })
        }

      }
    }

    if(this.props.settingsProjectLikelihood.data){
      for(let i=0; i<this.props.settingsProjectLikelihood.data.length; i++){
        projectLikelihood.push({
          name: this.props.settingsProjectLikelihood.data[i].ratio,
          value: this.props.settingsProjectLikelihood.data[i].id
        })
      }
    }

    if(this.props.internalProjects.itemId){
      itemData = this.props.internalProjects.itemData
    }
    const schema = [
      {
        type: "default",
        fields: [
          {
            type: "text",
            name: "project",
            label: "Project:",
            value: itemData?itemData.project:''
          },
          {
            type: "select",
            name: "officer_in_charge_id",
            label: "OIC:",
            value: itemData && itemData.officer_in_charge?itemData.officer_in_charge.id:'',
            options: users,
            disabled: this.props.user.inProgress
          },
          {
            type: "textarea",
            name: "note",
            label: "Notes:",
            value: itemData?itemData.note:''

          }
        ]
      }
    ]
    return (
      <section className="section-content">
        <Row>
          <Col xs={12} md={8} lg={6}>
            <SmartForm
              schema={schema}
              onSave={this._submit.bind(this)}
              showError={this.props.internalProjects.error && this.props.internalProjects.errorText}
              errorMessage={ this.props.internalProjects.errorText }
              onReset={this.props.internalProjectsShowList.bind(this)}
              loading={this.props.internalProjects.inProgress } />
          </Col>
        </Row>


      </section>
    )
  }

  _submit(data){
    if(this.props.internalProjects.itemId){
      this.props.internalProjectsUpdateItem(this.props.internalProjects.itemId, data)
    }else{
      this.props.internalProjectsAddItem(data)
    }
  }


}

export default InternalProjectsForm
